import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from 'src/app/pipes/translate.pipe';


@NgModule({
  declarations: [
    TranslatePipe
  ],
  imports: [
    CommonModule
  ],
  providers: [],
  exports: [
    TranslatePipe
  ]
})
export class CommonSharedModule { }
